export default __webpack_public_path__ + "static/media/ic-changepassword-hover.27335e2c.svg";